import PropTypes from 'prop-types'

import { useSelector } from 'react-redux'

import styled from '@emotion/styled'

import ClearFilterButton from '../ClearFilterButton'
import { selectLabel } from '../../../../flux/selectors/i18n'
import CategoryList from '../CategoryList'

const StyledRoot = styled.div(({ open }) => ({
  display: open ? 'block' : 'none',
  width: '300px',
  zIndex: '1',
  right: '24px',
  marginTop: '8px',
  position: 'absolute',
  background: 'white',
  boxShadow: '0 2px 4px 0 rgba(0,0,0,0.50)',
}))

const StyledHeader = styled.div(() => ({
  display: 'block',
}))

const StyledPrimaryHeader = styled.div(() => ({
  display: 'flex',
  padding: '20px 14px',
  justifyContent: 'space-between',
}))

const StyledPrimaryHeaderText = styled.span(() => ({
  fontSize: '14px',
  fontWeight: 'bold',
}))

const StyledPrimaryHeaderCta = styled.button(({ theme: { colors } }) => ({
  backgroundColor: 'transparent',
  border: 0,
  color: colors.primary,
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 'bold',
  margin: 0,
  padding: 0,
}))

const StyledSecondaryHeader = styled.div(({ theme: { colors } }) => ({
  display: 'block',
  padding: '8px 16px',
  borderTop: `1px solid ${colors.light_grey}`,
  borderBottom: `1px solid ${colors.light_grey}`,
}))

const StyledContainer = styled.div(() => ({
  maxHeight: '280px',
  background: 'white',
  overflowY: 'auto',
}))

const CategoriesDropdown = ({
  isOpen,
  selectedCategories,
  onClearFilterClick,
  onApplyFilterClick,
  onCategoryListItemClick,
}) => {
  const filtersLabel = useSelector(selectLabel('filters')).toUpperCase()
  const clearLabel = useSelector(selectLabel('uncheckAllCategories'))
  const okLabel = useSelector(selectLabel('ok')).toUpperCase()

  return (
    <StyledRoot open={isOpen} data-test="CategoriesDropdown">
      <StyledHeader>
        <StyledPrimaryHeader>
          <StyledPrimaryHeaderText>
            {filtersLabel}
          </StyledPrimaryHeaderText>
          <StyledPrimaryHeaderCta
            onClick={onApplyFilterClick}
            data-test="ApplyFilterButton"
          >
            {okLabel}
          </StyledPrimaryHeaderCta>
        </StyledPrimaryHeader>
        <StyledSecondaryHeader>
          <ClearFilterButton
            onClick={onClearFilterClick}
            label={clearLabel}
          />
        </StyledSecondaryHeader>
      </StyledHeader>
      <StyledContainer>
        <CategoryList
          selectedCategories={selectedCategories}
          onCategoryListItemClick={onCategoryListItemClick}
        />
      </StyledContainer>
    </StyledRoot>

  )
}

CategoriesDropdown.propTypes = {
  selectedCategories: PropTypes.arrayOf(
    PropTypes.string,
  ),
  isOpen: PropTypes.bool.isRequired,
  onClearFilterClick: PropTypes.func,
  onApplyFilterClick: PropTypes.func,
  onCategoryListItemClick: PropTypes.func,
}

CategoriesDropdown.defaultProps = {
  selectedCategories: [],
  onClearFilterClick: () => false,
  onApplyFilterClick: () => false,
  onCategoryListItemClick: () => false,
}

CategoriesDropdown.displayName = 'CategoriesDropdown'
CategoriesDropdown.whyDidYouRender = true

export default CategoriesDropdown
